var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.9905H14.5C14.7765 2.9905 15 3.2145 15 3.4905C15 3.7665 14.7765 3.9905 14.5 3.9905H13.5V14.748C13.5 15.4385 12.9385 16 12.248 16H3.752C3.062 16 2.5 15.4385 2.5 14.748V3.9905H1.5C1.224 3.9905 1 3.7665 1 3.4905C1 3.2145 1.224 2.9905 1.5 2.9905H5.5V2.5C5.5 1.1215 6.6215 0 8 0C9.3785 0 10.5 1.1215 10.5 2.5V2.9905ZM9.5 2.9905V2.5C9.5 1.673 8.827 1 8 1C7.173 1 6.5 1.673 6.5 2.5V2.9905H9.5ZM3.5 3.9905V14.748C3.5 14.887 3.613 15 3.752 15H12.248C12.387 15 12.5 14.887 12.5 14.748V3.9905H3.5ZM5.5 12.9905C5.224 12.9905 5 12.767 5 12.4905V6.4905C5 6.2145 5.224 5.9905 5.5 5.9905C5.776 5.9905 6 6.2145 6 6.4905V12.4905C6 12.767 5.776 12.9905 5.5 12.9905ZM10.5 12.9905C10.2235 12.9905 10 12.767 10 12.4905V6.4905C10 6.2145 10.2235 5.9905 10.5 5.9905C10.7765 5.9905 11 6.2145 11 6.4905V12.4905C11 12.767 10.7765 12.9905 10.5 12.9905ZM8 13.4905C7.724 13.4905 7.5 13.267 7.5 12.9905V5.9905C7.5 5.7145 7.724 5.4905 8 5.4905C8.276 5.4905 8.5 5.7145 8.5 5.9905V12.9905C8.5 13.267 8.276 13.4905 8 13.4905Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5224_77205",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 14,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2.9905H14.5C14.7765 2.9905 15 3.2145 15 3.4905C15 3.7665 14.7765 3.9905 14.5 3.9905H13.5V14.748C13.5 15.4385 12.9385 16 12.248 16H3.752C3.062 16 2.5 15.4385 2.5 14.748V3.9905H1.5C1.224 3.9905 1 3.7665 1 3.4905C1 3.2145 1.224 2.9905 1.5 2.9905H5.5V2.5C5.5 1.1215 6.6215 0 8 0C9.3785 0 10.5 1.1215 10.5 2.5V2.9905ZM9.5 2.9905V2.5C9.5 1.673 8.827 1 8 1C7.173 1 6.5 1.673 6.5 2.5V2.9905H9.5ZM3.5 3.9905V14.748C3.5 14.887 3.613 15 3.752 15H12.248C12.387 15 12.5 14.887 12.5 14.748V3.9905H3.5ZM5.5 12.9905C5.224 12.9905 5 12.767 5 12.4905V6.4905C5 6.2145 5.224 5.9905 5.5 5.9905C5.776 5.9905 6 6.2145 6 6.4905V12.4905C6 12.767 5.776 12.9905 5.5 12.9905ZM10.5 12.9905C10.2235 12.9905 10 12.767 10 12.4905V6.4905C10 6.2145 10.2235 5.9905 10.5 5.9905C10.7765 5.9905 11 6.2145 11 6.4905V12.4905C11 12.767 10.7765 12.9905 10.5 12.9905ZM8 13.4905C7.724 13.4905 7.5 13.267 7.5 12.9905V5.9905C7.5 5.7145 7.724 5.4905 8 5.4905C8.276 5.4905 8.5 5.7145 8.5 5.9905V12.9905C8.5 13.267 8.276 13.4905 8 13.4905Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5224_77205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#8A8E96"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrey);
export default __webpack_public_path__ + "static/media/trash-grey.daa1b3a015829e5f66d2449106dbb59a.svg";
export { ForwardRef as ReactComponent };